export default {
  historyImportState: {
    // 1 创建中 2 处理中 3 全部成功 4 全部错误 5部分错误
    1: '创建中',
    2: '处理中',
    3: '全部成功',
    4: '全部错误',
    5: '部分错误',
  },
  historyImportType: {
    34: '维保信息',
    35: '维保支付项',
    36: '违章记录',
    37: '企业租赁订单',
    38: '企业租赁子订单',
    39: '企业租赁子订单（已退）',
    41: '企业采购订单',
    42: '企业采购子订单',
    43: '企业采购子订单（已退）',
    67: '个人订单导入',
    68: '企业子订单导入',
  },
  projectTypesDetails: {
    0: '单品',
    1: '多次核销',
    2: '商品池',
  },
}
